import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-transcript",
  "use": "icon_player-transcript-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-transcript\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M14.0017 2H6.00169L4 2.00002 4.00169 4v16l.00002 2H20l.0017-2V8m-6-6 6 6m-6-6v6h6m-10 1H8.00169m8.00001 4H8.00169m8.00001 4H8.00169\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol